module.exports = __webpack_public_path__ + "static/media/image5.dd08a2fc.jpg";